import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { errorDetail } from "@/lib/api";
import { openPortal, startCheckout } from "@/lib/billing";
import { PageHead } from "@/components/hm/Basics";
import { Pricing } from "@/components/hm/Pricing";

export default function Planes() {
  const { user } = useAuth();
  const [loading, setLoading] = useState(null);
  const [error, setError] = useState("");
  const subscribed = user.has_access && user.has_subscription;

  const choose = async (planId, interval) => {
    if (subscribed) return openPortal();
    setLoading(planId); setError("");
    try { await startCheckout(planId, interval); }
    catch (e) { setError(errorDetail(e)); setLoading(null); }
  };

  return (
    <div data-testid="planes-page">
      <PageHead eyebrow="Planes" title="Elige cómo quieres" serif="acompañarte." lead="Pago con Stripe. Cambia o cancela tu plan cuando quieras desde tu cuenta." />
      {subscribed && (
        <div className="welcome-tile" style={{ marginBottom: 24 }} data-testid="planes-current-notice">
          <p style={{ margin: 0 }}>Ya tienes el plan {user.plan_name}. Para cambiarlo o cancelarlo, usa Gestionar mi plan.</p>
          <button className="btn btn-primary btn-sm" style={{ justifySelf: "start" }} onClick={openPortal} data-testid="planes-manage-button">Gestionar mi plan</button>
        </div>
      )}
      {error && <p className="form-error" style={{ marginBottom: 20 }} data-testid="planes-error">{error}</p>}
      <Pricing onChoose={choose} loadingId={loading} currentPlan={user.has_access ? user.plan : null}
        ctaLabel={subscribed ? "Cambiar desde mi cuenta" : "Elegir este plan"} />
      <p className="text-muted" style={{ marginTop: "2rem", fontSize: 14, textAlign: "center" }}>
        Las sesiones grupales e individuales se organizan por email o WhatsApp. Te escribimos después del pago para acordarlas.
      </p>
    </div>
  );
}
